<script>
  import { _ } from 'svelte-i18n'
	import { fade } from 'svelte/transition';
  import { tag_to_rename, tag_to_delete, previews_categories_filter, local_fonts, user_categorized_families, user_valid} from '../stores'
  import { previews_tags_filter, previews_are_google_fonts, previews_nav_filters, user_font_tags, detected_fonts, google_fonts, modals, user } from '../stores'
  import { toTitleCase } from '../modules/toTitleCase'
  import { filter, sortBy, uniq, flatMap, isEmpty } from 'lodash'
  import Pill from '../elements/Pill.svelte'
  import TagsEditToggle from './TagsEditToggle.svelte'
  import PreviewsWeightList from './PreviewsWeightList.svelte'
  import Button from '../elements/Button.svelte';
  import Blink from '../elements/Blink.svelte';

  // get tags from fonts for google fonts, get tags from user_fonts_tags store for user saved fonts
  $: tags = $previews_are_google_fonts ? uniq(flatMap($google_fonts, f => toTitleCase(f.tags[0]))).sort() : filter(sortBy($user_font_tags, [tag => tag.tag_name.toLowerCase()]), f => f.id)

  $: categorized_fonts = $previews_are_google_fonts ? null : filter($detected_fonts, f => f.categorized)
  // create a unique array of styles from category
  $: categories = uniq(flatMap(categorized_fonts, f => f.category)).sort()
  
  $: families_to_categorize_count = $previews_are_google_fonts ? 0 : uniq($detected_fonts?.map(font => font.family_name)).length
  $: families_categorized_count = $previews_are_google_fonts ? null : $user_categorized_families?.length
  $: families_uncategorized_count = families_to_categorize_count - families_categorized_count

  // if there are no uncategorized fonts, change the hide_categorization_message to true after 2 seconds
  let hide_categorization_message = false
  $: if (families_uncategorized_count === 0) {
    setTimeout(() => {
      hide_categorization_message = true
    }, 2000)
  }

  // we will ask openai to classify within these categories
  const placeholder_categories = ["serif","sans-serif","script","handwriting","display","decorative","monospaced","symbol"]

  function handleTagClick(selected_tag) {
    previews_tags_filter.toggleTag(selected_tag)
  }
  function handleCategoryClick(selected_category) {
    previews_categories_filter.toggleCategory(selected_category)
  }
  
  function toggleYours() {
    if ($previews_nav_filters.system) previews_nav_filters.toggleSystem()
    previews_nav_filters.toggleYours()
  }
  
  function openRenameModal(id) {
    $tag_to_rename = id
    modals.open('renameTag')
  }

  function openDeleteModal(id) {
    $tag_to_delete = id
    modals.open('deleteTag')
  }

</script>

  <div class="tagsContainer">
    {#if $previews_nav_filters.tagged || $previews_are_google_fonts}
      {#each tags as tag}
        <Pill 
        on:click="{() => handleTagClick(tag.id || tag.toLowerCase())}" 
        on:delete={() => openDeleteModal(tag.id || tag.toLowerCase())}
        on:rename={() => openRenameModal(tag.id || tag.toLowerCase())}
        active={$previews_tags_filter.includes(tag.id || tag.toLowerCase())}>
          {tag.tag_name || tag}
        </Pill>
      {/each}
    {/if}

    {#if $previews_nav_filters.tagged}
      <Pill 
        outline={true} 
        on:click={() => previews_nav_filters.toggleUntagged()}
        active={$previews_nav_filters.tagged === false}>
          {$_('buttons.untagged')}
      </Pill>

      {#if !$previews_nav_filters.tagged}
        <Pill 
          outline={true} 
          on:click={toggleYours}
          active={$previews_nav_filters.user === true}>
            {$_('buttons.yourUntaggedFonts')}
        </Pill>
      {:else if tags.length > 0}
        <TagsEditToggle/>
      {/if}
    {/if}

    {#if $previews_are_google_fonts}
      <PreviewsWeightList/>
    {/if}

    {#if ($previews_nav_filters.user || isEmpty($previews_nav_filters)) && !$previews_are_google_fonts}
      {#if $user?.feature_ai_categories_on}
        {#each categories as category}
          <Pill 
            outline={true}
            disabled= {!$user_valid}
            on:click="{() => handleCategoryClick(category)}" 
            active={$previews_categories_filter.includes(category)}>
              {toTitleCase(category)}
          </Pill>
        {/each}
        {#if families_uncategorized_count > 0}
          <Blink>
            Categorizing {families_uncategorized_count} fonts...
          </Blink>
        <!-- {:else if !hide_categorization_message}
          <span in:fade out:fade={{delay: 1000}}>
            👌 All fonts categorized
          </span> -->
        {/if}
        <!-- Handle user expired case -->
        {#if !$user_valid}
          <small>Upgrade to use smart categories</small>
        {/if}
      <!-- offer smart categories to local fonts users -->
      <!-- {:else if !isEmpty($local_fonts)}
        {#each placeholder_categories as category}
          <Pill 
            outline={true} 
            disabled={true}>
              {toTitleCase(category)}
          </Pill>
        {/each}
        <span class="accent">&larr;</span>
        <Button kind="reveal" size="small" on:click={()=> modals.open('smartCategories')}>✨ Try smart categories! ✨</Button> -->
      {/if}
    {/if}

  </div>

<style>
  .tagsContainer {
    padding: 0 2rem 1rem;
    margin-top: -1rem;
    line-height: 3rem;
    background-color: var(--c-nav-bg);
  }
  /* .accent {
    color: var(--c-accent);
    font-weight: bold;
    font-size: 1.6rem;
  } */
</style>
  